<template>
    <div class="max-w-4xl mx-auto w-full space-y-6">
        <div class="flex items-center justify-between">
            <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
                Edit Question
            </h1>
            <router-link
                to="/question-banks"
                class="text-primary-600 hover:text-primary-900 dark:text-primary-400 dark:hover:text-primary-300"
            >
                ← Back to Questions
            </router-link>
        </div>

        <div v-if="loading" class="flex justify-center items-center py-12">
            <div
                class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"
            ></div>
        </div>

        <div v-else class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <QuestionBankForm
                :question="questionData"
                :is-editing="true"
                @saved="handleSaved"
                @cancel="handleCancel"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useQuestionBankStore } from "@/stores/questionBankStore";
import QuestionBankForm from "@/modules/question-banks/components/QuestionBankForm.vue";
import NotificationService from "@/utils/notifications";
import type { QuestionBank } from "@/types/questionBank";

const route = useRoute();
const router = useRouter();
const questionBankStore = useQuestionBankStore();

const questionData = ref<QuestionBank | null>(null);
const loading = ref(false);

const loadQuestion = async () => {
    const questionId = route.params.id as string;
    loading.value = true;
    try {
        questionData.value = await questionBankStore.fetchQuestion(questionId);
    } catch (error) {
        console.error("Failed to load question:", error);
        NotificationService.error("Failed to load question");
        router.push("/question-banks");
    } finally {
        loading.value = false;
    }
};

const handleSaved = () => {
    NotificationService.success("Question updated successfully!");
    router.push("/question-banks");
};

const handleCancel = () => {
    router.push("/question-banks");
};

onMounted(() => {
    loadQuestion();
});
</script>
